import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./zerodhaclone.css";

import {
  Navigation,
  A11y,
  Pagination,
  Autoplay,
  EffectCoverflow,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-coverflow"; // For center mode effect
import { useState } from "react";
import { cards, descriptions, images, leftItems } from "./data";
import { useEffect } from "react";

const Zerodhaclone = () => {
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const handleSlideChange = (swiper) => {
    setIsPrevDisabled(swiper.isBeginning);
    setIsNextDisabled(swiper.isEnd);
  };

  const [isPrevMkDisabled, setIsPrevMkDisabled] = useState(true);
  const [isNextMkDisabled, setIsNextMkDisabled] = useState(false);

  const handleMkSlideChange = (market) => {
    setIsPrevMkDisabled(market.isBeginning);
    setIsNextMkDisabled(market.isEnd);
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const handleTypes = (index) => {
    setActiveIndex(index);
  };

  const [activeMarketInd, setActiveMarketInd] = useState(0);
  const [slideWidth, setSlideWidth] = useState(330);
  const [isLeftActive, setIsLeftActive] = useState(false);
  const [isRightActive, setIsRightActive] = useState(true);

  useEffect(() => {
    // Adjust slide width dynamically based on screen size
    const updateSlideWidth = () => {
      if (window.innerWidth <= 480) {
        setSlideWidth(268);
      } else if (window.innerWidth <= 576) {
        setSlideWidth(232);
      } else if (window.innerWidth <= 991 && window.innerWidth >= 768) {
        setSlideWidth(340);
      } else if (window.innerWidth <= 1024) {
        setSlideWidth(250);
      } else if (window.innerWidth <= 1200) {
        setSlideWidth(260);
      } else if (window.innerWidth <= 1500 && window.innerWidth >= 1450) {
        setSlideWidth(334);
      } else if (window.innerWidth <= 1800) {
        setSlideWidth(320);
      } else {
        setSlideWidth(330);
      }
    };

    updateSlideWidth();
    window.addEventListener("resize", updateSlideWidth);
    return () => window.removeEventListener("resize", updateSlideWidth);
  }, []);

  const slideLeft = () => {
    if (activeMarketInd > 0) {
      setActiveMarketInd((prev) => prev - 1);
      setIsRightActive(true);
      if (activeMarketInd - 1 === 0) setIsLeftActive(false);
    }
  };

  const slideRight = () => {
    if (activeMarketInd < cards.length - 1) {
      setActiveMarketInd((prev) => prev + 1);
      setIsLeftActive(true);
      if (activeMarketInd + 1 === cards.length - 1) setIsRightActive(false);
    }
  };

  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>Zerodha clone app</title>

        <meta name="title" content="Zerodha clone app" />
        <meta
          name="description"
          content="A Zerodha clone app is a customizable online trading platform replicating Zerodha’s features, enabling stock, commodity, and mutual fund trading. It offers advanced tools, real-time market data, and secure transactions."
        />

        <meta property="og:title" content="Zerodha Clone" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/zerodha-clone-app"
        />
      </Helmet>

      <main className="zerodha-main">
        {/* hero */}
        <article className="primary__landing__container">
          <div className="zerodha-hero-bg">
            <h1 className="zerodha-hero-title">Zerodha Clone App</h1>
            <p className="zerodha-hero-content">
              The financial world is rapidly transforming, with online trading
              platforms like Zerodha leading the way. If you are looking to
              create a Zerodha clone app, Beleaf technologies is your best
              option.
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="zerodha-primary-btn zero-hero-btn"
            >
              Get Free Consultation
            </button>
            <div className="zerodha-hero-img">
              <img
                src={require("../../../image/zerodha/hero.webp")}
                alt="Zerodha clone app"
              />
            </div>
          </div>
        </article>

        {/* about */}
        <article className="primary__landing-content-container">
          <div className="row zerodha-about-row">
            <div className="col-lg-6">
              <div>
                <h3 className="zer-sub-title clr-size">
                  What Is A <span className="zer-grad-span">Zerodha Clone</span>{" "}
                  App?
                </h3>
                <p className="zer-sub-content content-clr">
                  {" "}
                  A Zerodha clone app is a ready-to-develop solution that
                  enables businesses to offer a robust trading experience
                  similar to Zerodha, but with unique customizations to stand
                  out in the competitive market. It replicates the features and
                  functionalities of Zerodha, a popular online trading platform.
                  It allows users to trade in stocks, commodities, derivatives,
                  and mutual funds efficiently. Businesses can add custom
                  features to create a unique platform developed to their
                  audience's needs.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="zerodha-primary-btn about-btn"
                >
                  Get Free Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="zerodha-about-col">
                <img
                  src={require("../../../image/zerodha/about-bg.webp")}
                  alt="Zerodha clone app"
                />
              </div>
            </div>
          </div>
        </article>

        {/* why build */}
        <article className="primary__landing-content-container">
          <div className="zerodha-hero-bg why-build-bg">
            <div className="row zer-why-build-row">
              <div className="col-lg-6">
                <div>
                  <img
                    src={require("../../../image/zerodha/build.webp")}
                    alt="Zerodha clone app"
                  />
                </div>
              </div>
              <div className="col-lg-6 zer-why-col">
                <div>
                  <h3 className="zer-sub-title clr">
                    <span className="zer-grad-span">Why Build a</span> Zerodha
                    Clone App?
                  </h3>
                  <p className="zer-sub-content built-content-clr">
                    Creating a Zerodha clone app can help you enter the online
                    trading market with a proven business model. With millions
                    of users joining the online trading wave, the demand for
                    user-friendly trading platforms is skyrocketing.  Platforms
                    like Zerodha earn through brokerage fees, subscription
                    plans, and premium features. A Zerodha clone app can
                    replicate this revenue model. The app can accommodate
                    multiple asset classes, making it flexible for growth.
                    Unlike starting from scratch, a clone app allows you to
                    innovate by adding new features or branding elements.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="zerodha-primary-btn zero-hero-btn"
                  >
                    Get Consultation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* Essential */}
        <article className="primary__landing-content-container">
          <h3 className="zer-sub-title ess-clr-size">
            Essential <span className="zer-grad-span">Features of</span> a
            Zerodha Clone App
          </h3>
          <p className="zer-sub-content ess-content-clr-size">
            To succeed in the trading industry, your Zerodha clone app should
            include these key features
          </p>

          <div className="zer-slider-container">
            <Swiper
              spaceBetween={90}
              slidesPerView={3}
              navigation
              modules={[Pagination, Autoplay, EffectCoverflow]}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 2000, // Auto-slide every 2 seconds
                disableOnInteraction: false,
              }}
              effect="coverflow"
              centeredSlides={true}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2,
                slideShadows: false,
              }}
              loop={true} // To enable infinite scrolling
              breakpoints={{
                // Breakpoint for small screens
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                // Breakpoint for medium screens
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                // Breakpoint for larger screens
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
            >
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/user-reg.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">
                      User Registration & Profile Management
                    </h5>
                    <p className="zer-ess-card-content">
                      Simplify the onboarding process with user-friendly
                      registration. Allow users to set up and manage their
                      profiles with complete security.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/real-time.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">
                      Real-Time Market Data
                    </h5>
                    <p className="zer-ess-card-content">
                      Offer real-time updates on stock prices, market trends,
                      and news. Accurate data keeps users engaged and informed.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/multi-asset.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">Multi-Asset Trading</h5>
                    <p className="zer-ess-card-content">
                      Enable trading across stocks, derivatives, commodities,
                      mutual funds, and more. A diverse portfolio attracts a
                      broader user base.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/intuitive.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">
                      Intuitive User Interface (UI)
                    </h5>
                    <p className="zer-ess-card-content">
                      An elegant and user-friendly interface improves the
                      overall user experience. Mimic Zerodha’s minimalistic
                      design for seamless navigation.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/advanced.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">
                      Advanced Charting Tools
                    </h5>
                    <p className="zer-ess-card-content">
                      Provide advanced charting tools for technical analysis.
                      Include indicators like moving averages, RSI, and
                      Bollinger Bands.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/portfolio.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">Portfolio Management</h5>
                    <p className="zer-ess-card-content">
                      Allow users to track and manage their investments
                      effectively with detailed insights and analytics.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/secure-payment.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">
                      Secure Payment Gateway
                    </h5>
                    <p className="zer-ess-card-content">
                      Integrate a secure payment system to facilitate deposits
                      and withdrawals. Ensure compliance with financial
                      regulations.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="zer-ess-card">
                  <div className="zer-ess-inner">
                    <img
                      src={require("../../../image/zerodha/risk-manage.webp")}
                      alt="Zerodha clone app"
                      className="m-auto"
                    />
                    <h5 className="zer-ess-card-title">
                      Risk Management Tools
                    </h5>
                    <p className="zer-ess-card-content">
                      Include tools like stop-loss, margin calculators, and risk
                      analysis to help users make informed decisions.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </article>

        {/* Benefits */}
        <article className="primary__landing-content-container">
          <div className="zer-benefits-bg">
            <h2 className="zer-sub-title zer-benefits-clr">
              <span className="zer-grad-span">Benefits of</span> a Zerodha Clone
              App
            </h2>

            <div className="zer-slider-wrap">
              <Swiper
                className="zer-swiper"
                // spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".zer-prev-arrow",
                  nextEl: ".zer-next-arrow",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  700: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                }}
                onSlideChange={handleSlideChange}
                onReachBeginning={() => setIsPrevDisabled(true)}
                onReachEnd={() => setIsNextDisabled(true)}
                onFromEdge={() => {
                  setIsPrevDisabled(false);
                  setIsNextDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="zer-swiper-cards">
                    {/* <img src={cardOne} alt="Uber clone" /> */}
                    <h5>Faster Market Entry</h5>
                    <div className="zer-slider-img">
                      <img
                        src={require("../../../image/zerodha/faster-market.webp")}
                        alt="Zerodha clone app"
                      />
                    </div>
                    <p>
                      With a pre-built framework, a Zerodha clone app helps you
                      launch quickly, saving time on development.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="zer-swiper-cards">
                    <h5>Cost-Effective</h5>
                    <div className="zer-slider-img">
                      <img
                        src={require("../../../image/zerodha/cost-effective.webp")}
                        alt="Zerodha clone app"
                      />
                    </div>
                    <p>
                      Developing a clone app is more affordable than building a
                      trading platform from scratch.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="zer-swiper-cards">
                    <h5>Customizable Features</h5>
                    <div className="zer-slider-img">
                      <img
                        src={require("../../../image/zerodha/customizable-feature.webp")}
                        alt="Zerodha clone app"
                      />
                    </div>
                    <p>
                      Tailor the app to suit your business requirements, such as
                      branding, unique tools, or payment options.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="zer-swiper-cards">
                    <h5>Enhanced User Experience</h5>
                    <div className="zer-slider-img">
                      <img
                        src={require("../../../image/zerodha/enhance-ux.webp")}
                        alt="Zerodha clone app"
                      />
                    </div>
                    <p>
                      By incorporating Zerodha’s proven features, your app can
                      deliver a top-notch trading experience.
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <button
                className={`zer-prev-arrow ${isPrevDisabled ? "disabled" : ""}`}
                style={{
                  color: isPrevDisabled ? "#000" : "#000",
                  cursor: isPrevDisabled ? "not-allowed" : "pointer",
                  background: isPrevDisabled ? "#636567" : "#fff",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`zer-next-arrow ${isNextDisabled ? "disabled" : ""}`}
                style={{
                  color: isNextDisabled ? "#000" : "#000",
                  cursor: isNextDisabled ? "not-allowed" : "pointer",
                  background: isNextDisabled ? "#636567" : "#fff",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>

            <div className="zer-ben-btn">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="zerodha-primary-btn zero-hero-btn"
              >
                Get Consultation
              </button>
            </div>
          </div>
        </article>

        {/* develop */}
        <article className="primary__landing-content-container">
          <div className="zer-develop">
            <h3 className="zer-sub-title zer-develop-size">
              How to <span className="zer-grad-span">Develop a</span> Zerodha
              Clone App?
            </h3>

            <div className="row zer-develop-row">
              <div className="col-lg-6">
                <div className="zer-develop-left-wrap">
                  {leftItems.map((title, index) => (
                    <div
                      className={`zer-develop-left ${
                        activeIndex === index ? "active" : ""
                      }`}
                      key={index}
                    >
                      <h5>#{index + 1}</h5>
                      <div className="zer-width">
                        <div className="d-flex align-items-center justify-content-between">
                          <h6
                            className="zer-develop-left-title"
                            onClick={() => handleTypes(index)}
                          >
                            {title}
                          </h6>
                          <span>
                            <i className="fa-solid fa-chevron-right"></i>
                          </span>
                        </div>
                        <p className="zer-develop-left-content">
                          {descriptions[index]}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="zer-dev-right">
                  <div className="zer-dev-right-inner">
                    <div
                      className="zer-dev-img-track"
                      style={{
                        transform: `translateY(-${activeIndex * 300}px)`,
                        transition: "transform 0.5s ease-in-out",
                      }}
                    >
                      {images.map((src, index) => (
                        <div className="zer-dev-img-wrap" key={index}>
                          <img src={src} alt={`Slide ${index}`} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* customization */}
        <article className="primary__landing-content-container zer-custom">
          <h2 className="zer-sub-title zer-custom-size">
            <span className="zer-grad-span">Customization Options</span> for
            Your Zerodha Clone App
          </h2>

          <div className="row zer-custom-row">
            <div className="col-lg-4">
              <div className="zer-custom-box">
                <div className="zer-custom-pad">
                  <div>
                    <h6 className="zer-custom-box-title">
                      AI-Powered Recommendations
                    </h6>
                    <p className="zer-custom-box-content">
                      Help users make better trading decisions with AI insights.
                    </p>
                  </div>
                  <div className="zer-custom-box-img">
                    <img
                      src={require("../../../image/zerodha/ai.webp")}
                      alt="Zerodha clone app"
                    />
                  </div>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="zer-custom-btn"
                  >
                    Learn More{" "}
                    <span className="mx-2">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>{" "}
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="zer-custom-flex-container">
                <div className="zer-custom-box">
                  <div className="zer-custom-pad">
                    <div>
                      <h6 className="zer-custom-box-title">Social Trading</h6>
                      <p className="zer-custom-box-content">
                        Allow users to follow expert traders and copy their
                        strategies.
                      </p>
                    </div>
                    <div className="d-flex align-items-end justify-content-between w-100">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="zer-custom-btn"
                      >
                        Learn More{" "}
                        <span className="mx-2">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>{" "}
                      </button>
                      <div>
                        <img
                          src={require("../../../image/zerodha/social.webp")}
                          alt="Zerodha clone app"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="zer-custom-box">
                  <div className="zer-custom-pad">
                    <div>
                      <h6 className="zer-custom-box-title">
                        Multi-Language Support
                      </h6>
                      <p className="zer-custom-box-content">
                        Cater to a global audience by offering multiple
                        languages.
                      </p>
                    </div>
                    <div className="d-flex align-items-end justify-content-between w-100">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="zer-custom-btn"
                      >
                        Learn More{" "}
                        <span className="mx-2">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>{" "}
                      </button>
                      <div>
                        <img
                          src={require("../../../image/zerodha/multi.webp")}
                          alt="Zerodha clone app"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="zer-custom-flex-container">
                <div className="zer-custom-box">
                  <div className="zer-custom-pad">
                    <div>
                      <h6 className="zer-custom-box-title">Gamification</h6>
                      <p className="zer-custom-box-content">
                        Add rewards and achievements to enhance user engagement.
                      </p>
                    </div>
                    <div className="d-flex align-items-end justify-content-between w-100">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="zer-custom-btn"
                      >
                        Learn More{" "}
                        <span className="mx-2">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>{" "}
                      </button>
                      <div>
                        <img
                          src={require("../../../image/zerodha/gamification.webp")}
                          alt="Zerodha clone app"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="zer-custom-box">
                  <div className="zer-custom-pad">
                    <div>
                      <h6 className="zer-custom-box-title">
                        Blockchain Integration
                      </h6>
                      <p className="zer-custom-box-content">
                        Secure transactions with blockchain technology.
                      </p>
                    </div>
                    <div className="d-flex align-items-end justify-content-between w-100">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="zer-custom-btn"
                      >
                        Learn More{" "}
                        <span className="mx-2">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>{" "}
                      </button>
                      <div>
                        <img
                          src={require("../../../image/zerodha/blockchain.webp")}
                          alt="Zerodha clone app"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="zer-cus-btn-mt">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="zerodha-primary-btn about-btn"
            >
              Get Free Consultation
            </button>
          </div>
        </article>

        {/* marketing */}
        <article className="primary__landing-content-container zer-custom">
          <div className="zer-marketing">
            <h2 className="zer-sub-title zer-mar-title">
              <span className="zer-grad-span">Marketing Your </span>
              Zerodha Clone App
            </h2>
            <p className="zer-sub-content zer-mar-content-size">
              To succeed in the trading industry, your Zerodha clone app should
              include these key features
            </p>

            

            <div>
              <div className="zer-mk-bg">
                <Swiper
                  className="zer-swiper "
                  // spaceBetween={30}
                  slidesPerView={4}
                  modules={[Navigation, A11y, Pagination]}
                  pagination={{
                    clickable: true,
                  }}
                  centeredSlides={true}
                  scrollbar={{ draggable: true }}
                  navigation={{
                    prevEl: ".zer-mk-prev",
                    nextEl: ".zer-mk-nxt",
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    480: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    700: {
                      slidesPerView: 2,
                      spaceBetween: 0,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                    1430: {
                      slidesPerView: 4,
                      spaceBetween: 26,
                    },
                  }}
                  onSlideChange={handleMkSlideChange}
                  onReachBeginning={() => setIsPrevMkDisabled(true)}
                  onReachEnd={() => setIsNextMkDisabled(true)}
                  onFromEdge={() => {
                    setIsPrevMkDisabled(false);
                    setIsNextMkDisabled(false);
                  }}
                >
                  <SwiperSlide>
                    <div className="zer-mk-card-outer">
                      <div className="zer-mk-cards">
                        <h5 className="zer-mk-title">Social Media Campaigns</h5>
                        <p className="zer-mk-content">
                          Use platforms like Facebook and LinkedIn to reach
                          potential traders.
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="zer-mk-card-outer">
                      <div className="zer-mk-cards">
                        <h5 className="zer-mk-title">
                          Influencer Partnerships
                        </h5>
                        <p className="zer-mk-content">
                          Collaborate with trading influencers to promote your
                          app.
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="zer-mk-card-outer">
                      <div className="zer-mk-cards">
                        <h5 className="zer-mk-title">
                          Search Engine Optimization (SEO)
                        </h5>
                        <p className="zer-mk-content">
                          Optimize your website with keywords like Zerodha clone
                          app to attract organic traffic.
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="zer-mk-card-outer">
                      <div className="zer-mk-cards">
                        <h5 className="zer-mk-title">Referral Programs</h5>
                        <p className="zer-mk-content">
                          Encourage existing users to bring new users through
                          rewards.
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className="zer-slider-btn">
                <button
                  className={`zer-mk-prev slider-btn ${
                    isPrevMkDisabled ? "disabled" : ""
                  }`}
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <button
                  className={`zer-mk-nxt slider-btn ${
                    isNextMkDisabled ? "disabled" : ""
                  }`}
                >
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* conclusion */}
        <article className="zer-conclusion">
          <div className="primary__landing-content-container">
            <div className="row zer-con-row">
              <div className="col-lg-6 zer-left-con-col">
                <div>
                  <img
                    src={require("../../../image/zerodha/conclusion.webp")}
                    alt="Zerodha clone app"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <h2 className="zer-sub-title">
                  <span className="zer-grad-span">Conclusion</span>
                </h2>
                <p className="zer-sub-content zer-content-clr">
                  A Zerodha clone app provides a golden opportunity to tap into
                  the booming online trading market. With its user-friendly
                  features, robust functionality, and customization options, you
                  can create a platform that attracts traders and investors
                  worldwide. Partner with the right development team to ensure
                  your app stands out and delivers an exceptional trading
                  experience. Start your journey with a Zerodha clone app today
                  and enable traders to achieve their financial goals!
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="zerodha-primary-btn zero-hero-btn"
                >
                  Get Consultation
                </button>
              </div>
            </div>
          </div>
        </article>
      </main>

      {/* FAQ */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
                {/* <div className="landing-content-inline">
                  <span className="faq-span">Questions.</span>
                </div> */}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How long does it take to develop a Zerodha clone app?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The development time for a Zerodha clone app depends
                          on the complexity of the features and customizations.
                          Typically, it can take 3–6 months for a fully
                          functional app.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Is a Zerodha clone app secure for trading?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, a Zerodha clone app can be highly secure if built
                          with encryption, two-factor authentication, and other
                          robust security protocols to protect user data and
                          transactions.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Can I customize the features of a Zerodha clone app?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Absolutely! A Zerodha clone app can be tailored to
                          include additional features, unique branding, and
                          advanced trading tools to meet specific business
                          requirements.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          What are the revenue streams for a Zerodha clone app?
                        </a>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          You can generate revenue through brokerage fees,
                          subscription plans, premium features, advertising, and
                          referral programs within your Zerodha clone app.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Zerodhaclone;
